<template>
  <b-card body-class="mb-0" class="mb-0 text-dark">
    <b-row class="align-items-center">
      <b-col cols="auto">
        <div class="restaurant-image bg-dark position-relative" :style="`background: url(${photo})`">
          <div
            @click="modal = true"
            class="w-100 position-absolute text-white text-center upload-photo-image p-2" style="bottom: 0; left: 0">
            <font-awesome-icon icon="camera" class="align-middle mx-1"/>
            Change image
          </div>
        </div>
      </b-col>
      <b-col class="flex-grow-1">
        <div class="font-weight-bold text-dark h5">
          {{value.RestaurantName}}
        </div>
        <section class="detail-info">
          <div class="mb-2">
            {{ value.Cuisine }}
            
          </div>
          <div>
            {{ value.Address1 + ' ' + value.City + ', ' + value.State + ' ' + value.ZIP}}
          </div>
         

          <div>
            <a href="tel: '${this.value.Phone1}'">
              {{formatPhoneNumber(value.Phone1)}}
            </a>
          </div>
          <div v-if="value.Phone2">
            <a href="tel: '${this.value.Phone2}'">
              {{formatPhoneNumber(value.Phone2)}}
            </a>
          </div>
          <div v-if="value.RestaurantWorkingHoursToday.length">
            {{
            value.RestaurantWorkingHoursToday &&
            value.RestaurantWorkingHoursToday[0].StartTime
            }}
            -
            {{
            value.RestaurantWorkingHoursToday &&
            value.RestaurantWorkingHoursToday[0].EndTime
            }}
            <i>(Today)</i>
          </div>
          <div v-if="value.PreparationTime_Minutes">
            Order Preparation Time: Approx.
            {{ value.PreparationTime_Minutes }} min
          </div>
        </section>
      </b-col>
    </b-row>
    <upload-photo
      :title="value.LogoImage ? 'Logo Image Change' : 'Logo Image Upload'"
      :has-photo="!!value.LogoImage"
      v-model="modal"
      :ratio="1/1"
      @upload="upload"
      @delete="deletePhoto"
      :progressing="progressing"/>
  </b-card>
</template>

<script>
  import UploadPhoto from "../../../shared/UploadPhoto";
  import config from "SrcConfig";
  export default {
    name: "baseInfo",
    components: {UploadPhoto},
    props: {
      value: {
        required: true,
        type: Object,
        default: {}
      },
      progressing: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        modal: false
      }
    },
    computed: {
      photo () {
        let baseurl = config.files.baseurlimage;
        if (baseurl.search('www') != -1) {
          return "https://images.menupoly.com" + this.value.LogoImage
        }
        return baseurl + this.value.LogoImage
      }
    },
    methods: {
      formatPhoneNumber(phone) {
        return phone
          ? phone.replace(/^(\+1)?(\d{3})(\d{3})(\d{0,4})$/, (m, cc, a, b, c) => {
              let num = [a, b, c].filter(Boolean).join("-");
              return (cc ? "+1 " : "") + num;
            })
          : '';
      },
      upload (data) {
        this.$emit('updateImage', data)
      },
      deletePhoto () {
        this.$emit('deleteImage')
      },
      closeModal () {
        this.modal = false
      }
    }
  }
</script>

<style scoped>

</style>
